module.exports = __webpack_public_path__ + "img/6.f8d0d127.png";